import { Users } from '@platform/client';
import { OrgRepUser } from '@platform/client/schemas';
import EVENTS from '../analytics/events';
import dataTestids from '../constants/test-ids';
import { ROUTES } from '../routes/consts';
import NavbarDropdown, { NavbarDropdownItem } from './NavbarDropdown';

/** Shows org-level nav links for org rep users in the Dasbhoard */
const OrganizationDropdown = () => {
  const userData = Users.useGetCurrentUser<OrgRepUser>();

  const menuItems: NavbarDropdownItem[] = [
    {
      title: 'Edit Profile',
      href: ROUTES.EDIT_PROFILE,
      linkType: 'internal',
      eventName: EVENTS.DASHBOARD.ORG_DROPDOWN.EDIT_PROFILE_CLICKED,
    },
    {
      title: 'Preview Profile',
      href: `${ROUTES.DIRECTORY}/organizations/${userData?.data?.organization?.id}`,
      linkType: 'internal',
      eventName: EVENTS.DASHBOARD.ORG_DROPDOWN.PREVIEW_PROFILE_CLICKED,
    },
    {
      title: 'Invite a Team Member',
      href: ROUTES.INVITE_ORG_COLLEAGUE,
      linkType: 'internal',
      eventName: EVENTS.DASHBOARD.ORG_DROPDOWN.INVITE_TEAM_MEMBER_CLICKED,
    },
  ];

  return (
    <NavbarDropdown
      avatar={''}
      avatarFallbackIcon='building-04'
      buttonText={
        userData.isSuccess && userData.data?.organization?.name ?
          userData.data?.organization.name
          : ''
      }
      isLoading={!userData.isSuccess}
      items={menuItems}
      dataTestId={dataTestids.LAYOUT.ORG_DROPDOWN}
    />
  );
};

export default OrganizationDropdown;
